import { RegistrarLogErro } from "./clientefiel"

export function removeNull(obj) {
    if (Array.isArray(obj)) return obj.map(removeNull)

    return Object.fromEntries(
        Object.entries(obj)
            .filter(([_, value]) => value != null)
            .map(([key, value]) => [key, value === Object(value) ? removeNull(value) : value])
    )
}

export function removeEstabelecimento(obj) {
    // Mantém somente estabelecimento.id
    if (Array.isArray(obj)) {
        return obj.map(removeEstabelecimento)
    } else if (obj !== null && typeof obj === "object") {
        const newObj = {}
        for (const key in obj) {
            if (key === "estabelecimento") {
                // Se for um objeto, mantém só o id (se existir)
                const est = obj[key]
                newObj[key] = est && typeof est === "object" && "id" in est ? { id: est.id } : null
            } else {
                newObj[key] = removeEstabelecimento(obj[key])
            }
        }
        return newObj
    }
    return obj
}

export const iniciouLive = al => {
    const hoje = new Date()
    const { inicioDivulgacao, fimDivulgacao, dataRealizacaoInicio } = al

    if (
        dataRealizacaoInicio <= hoje.getTime() &&
        dataRealizacaoInicio + 3600000 >= hoje.getTime()
    ) {
        return `ENTRAR`
    }

    if (
        new Date(dataRealizacaoInicio).getDate() === hoje.getDate() &&
        dataRealizacaoInicio + 3600000 > hoje.getTime()
    ) {
        return `HOJE ${al.inicio ? `${al.inicio}hrs` : ""}`
    }

    if (dataRealizacaoInicio <= hoje.getTime()) {
        return "ACESSAR"
    }

    return formatarData(dataRealizacaoInicio)
}

const meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"]

export const dataFormatada = data => {
    return `${transformaDia(data)}/${transformaMes(data)}/${data.getFullYear()}`
}

const transformaDia = function (data) {
    const dia = new Date(data).getDate()
    const diaF = dia.length > 1 ? "0" + dia : dia

    return diaF
}

const transformaMes = function (data) {
    let mes = new Date(data).getMonth()
    mes = meses[mes]
    return mes.toLowerCase()
}

export function tratarResposta(response, metodo) {
    if (response.data) {
        return {
            response: response.data.response,
            message: response.data.message,
            status: response.status,
            statusText: response.statusText,
        }
    } else {
        const data = {
            response: [],
            message: `${metodo} não foi possivel, tire uma foto desse erro e avise para os responsáveis. Status ${1000}: ${
                response.message
            }`,
            status: 1000,
            statusText: `error`,
        }
        return data
    }
}

export function parseReal(valor) {
    return Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor)
}

export function getMoney(str) {
    var tmp = str.replace(/[\D]+/g, "")
    return parseInt(tmp === "" ? 0 : tmp)
}

export function formatReal(int) {
    var tmp = int + ""
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1")
    if (tmp.length > 6) tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2")

    return tmp
}

export function FormataStringData(data, inicio = true) {
    var dia = data.split("/")[0]
    var mes = data.split("/")[1]
    var ano = data.split("/")[2]

    return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia).slice(-2) + inicio
        ? " 00:00:00"
        : " 23:59:59"
}

export const formatarData = data => {
    data = new Date(data)
    return data.toISOString().substr(0, 10).split("-").reverse().join("/")
}

export function mandarImprimir(texto, qtd) {
    try {
        document.getElementById("rootPrint").innerHTML = texto.replace(/(?:\r\n|\r|\n)/g, "<br>")

        window.setTimeout(function () {
            window.print()
        }, 500)
    } catch (error) {
        RegistrarLogErro(error, "mandarImprimir", { texto, qtd })
    }
}

// TODO: Substituir todos que usam por DialogInformacoesPedido
export const textoHTML = texto => {
    window.setTimeout(function () {
        try {
            document.getElementById("textoHTML").innerHTML = texto
                .replace(/(?:\r\n|\r|\n)/g, "<br>")
                .replace("<br>", "")
                .replace("<br>", "")
                .replace("<br>", "")
        } catch (error) {}
    }, 500)
}

export function removeAcento(text) {
    try {
        text = text.toLowerCase()
        text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a")
        text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e")
        text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i")
        text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o")
        text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u")
        text = text.replace(new RegExp("[Ç]", "gi"), "c")
        return text
    } catch (error) {
        RegistrarLogErro(error, "removeAcento", text)
    }
}

export function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item)
}

export function mergeDeep(target, ...sources) {
    if (!sources.length) return target
    const source = sources.shift()

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} })
                mergeDeep(target[key], source[key])
            } else {
                Object.assign(target, { [key]: source[key] })
            }
        }
    }

    return mergeDeep(target, ...sources)
}
